export default class AddCATInvoiceImageModel {
  public id: string
  public jobId: string
  public blobUrl: string
}
